import React from "react";

interface LoadingProps {
  message?: string;
}

const Loading: React.FC<LoadingProps> = ({
  message = "Processing your request...",
}) => {
  return (
    <div className="fixed top-6 left-1/2 transform -translate-x-1/2 flex items-center bg-gray-900/90 text-white px-5 py-3 rounded-full shadow-2xl z-50 animate-slide-down backdrop-blur-md loading-container">
      <div className="flex items-center space-x-4">
        {/* <div className="w-6 h-6 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div> */}
        <span className="text-sm font-bold tracking-wide">{message}</span>
      </div>
    </div>
  );
};

export default Loading;
